export default "__VITE_ASSET__Zeua638B__"